import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A link inside a report/worklist table cell — the one styling for "this cell
 * navigates somewhere". Report tables render dozens of rows, so the affordance
 * has to be identical everywhere for a scanning eye to trust it.
 */
export const ReportLink: React.FC<{
  to: string;
  children: React.ReactNode;
}> = ({ to, children }) => (
  <Link
    to={to}
    className='font-medium text-primary underline-offset-2 hover:underline'
    onClick={event => event.stopPropagation()}
  >
    {children}
  </Link>
);
